export default __webpack_public_path__ + "static/media/project-information-colored-icon.7fb8b53e.svg";